const CAMPOS_FILTRABLES = [
    'idEvaluacion',
    'paciente',
    'programa',
    'planCuidado'
];

export const filtrarLiquidacionesPorTexto = (liquidacionesPorProfesional, texto) => {
    const filtro = texto?.trim().toLowerCase();

    if (!filtro) return liquidacionesPorProfesional;

    return liquidacionesPorProfesional
        .map((profesional) => ({
            ...profesional,
            liquidaciones: profesional.liquidaciones.filter((liquidacion) =>
                CAMPOS_FILTRABLES.some((campo) =>
                    String(liquidacion[campo] ?? '').toLowerCase().includes(filtro)
                )
            )
        }))
        .filter((profesional) => profesional.liquidaciones.length > 0);
};
